import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/_helpers/store';
import CustomLoader from './components/shared/CustomLoder';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './fonts/Montserrat-Bold.ttf';
import './fonts/Montserrat-Medium.ttf';
import './fonts/Montserrat-Regular.ttf';
import './fonts/Montserrat-SemiBold.ttf';
//import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
//import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// import App from './components/pages/dashboardAndReport/DashboardAndReport';

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={"loading"} persistor={persistor}>
      <App />
      <CustomLoader />
    </PersistGate>
 </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
